<mat-card appearance="outlined" class="mat-elevation-z0">
  <ng-content select="card-line-1">
  </ng-content>
  <mat-divider class="app-divider"></mat-divider>
  <ng-content select="card-line-2">
  </ng-content>
</mat-card>